import { FlexSalaryClient } from "@/api/flexsalary_http_client";
import { ErrorModel } from "@/models/ErrorModel";
import { StatisticRepository } from "../StatisticRepository";
import { mapTotalStatisticResponseModel } from "../adapters/statistic-adapter";
import {
  EmployeePaidInfoModel,
  PaidChartItemModel,
  TotalStatisticResponseModel,
} from "../models/StatisticModel";

export class StatisticRepositoryImp implements StatisticRepository {
  private _c: FlexSalaryClient;
  constructor(flexsalaryClient: FlexSalaryClient) {
    this._c = flexsalaryClient;
  }

  public async getPaidChart({
    fromDate,
    toDate,
  }: {
    fromDate?: number;
    toDate?: number;
  }): Promise<Array<PaidChartItemModel>> {
    try {
      let resp = await this._c.statistic.getPaidChart({
        fromDate: fromDate,
        toDate: toDate,
      });
      if (resp.data.code === 20000) {
        return resp.data.data?.paidList ?? [];
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async getTotalStatisticCurrentPeriod(): Promise<TotalStatisticResponseModel> {
    try {
      let resp = await this._c.statistic.getTotalStatisticCurrentPeriod();
      if (resp.data.code === 20000) {
        return mapTotalStatisticResponseModel(resp.data.data);
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }

  public async getPaidList({
    keyword,
    fromDate,
    toDate,
    salaryPeriodId,
  }: {
    keyword?: string;
    fromDate?: number;
    toDate?: number;
    salaryPeriodId?: string;
  }): Promise<EmployeePaidInfoModel[]> {
    try {
      let resp = await this._c.statistic.getPaidList({
        keyword: keyword,
        fromDate: fromDate,
        salaryPeriodId: salaryPeriodId,
        toDate: toDate,
      });
      if (resp.data.code === 20000) {
        return resp.data.data ?? [];
      } else {
        throw new ErrorModel({
          code: resp.data.code,
          message: resp.data.message,
        });
      }
    } catch (error) {
      throw error;
    }
  }
}
